"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
var _FissionUploadImg = _interopRequireDefault(require("./FissionUploadImg"));
var _FissionCreatePrizePane = _interopRequireDefault(require("./FissionCreatePrizePane.vue"));
var _sys_cons = require("@/api/sys_cons");
var _fission = require("@/api/activity/fission");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'FissionCreatePane',
  components: {
    FissionUploadImg: _FissionUploadImg.default,
    FissionCreatePrizePane: _FissionCreatePrizePane.default
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    var _this = this;
    return {
      loading: false,
      imageAccessDomain: '',
      // 图片访问域名
      memberLevelList: [],
      // 会员等级列表
      gagaAreaList: [],
      // gaga区域列表
      form: {
        title: '',
        // 活动标题
        subtitle: '',
        // 活动副标题
        activityTime: [],
        // 活动时间
        stock: 1,
        // 库存数量，初始值设为1
        enabled: false,
        // 是否启动，初始值设为false
        checkScalper: false,
        // 是否验证黄牛
        inviteCount: 5,
        // 邀请人数，初始值设为5
        cityRestriction: 1,
        // 城市限制，初始值设为1
        cityIds: [],
        // 城市ID列表
        headerImage: '',
        // 活动页头图
        bgColor: '',
        // 活动页背景色
        thirdLayerBgColor: '',
        // 第三层背景色
        fissionCardFgColor: '',
        // 裂变卡片前景色
        otherCardFgColor: '',
        // 其他卡片前景色
        cardTitleColor: '',
        // 卡片标题色
        fissionNumColor: '',
        // 剩余裂变数字颜色
        btnTextColor: '',
        // 按钮文字色1
        btnBgColor: '',
        // 按钮背景色1
        btnTextColor2: '',
        // 按钮文字色2
        btnBgColor2: '',
        // 按钮背景色2
        progressIcon: '',
        // 进度icon
        progressBarImage: '',
        // 进度条切图
        helperBackgroundImage: '',
        // 助力人背景图
        shareCardImage: '',
        // 分享卡片图
        posterImage: '',
        // 海报图
        fissionPopupBg: '',
        // 领取裂变弹窗背景图
        fissionNumBgImg: '',
        // 剩余裂变数字背景图
        initiatorRewardImage: '',
        // 发起者奖励图
        helperRewardImage: '',
        // 助力者奖励图
        middlePageImage: '',
        // 中间页展示图
        ruleText: '',
        // 规则文本
        initiatorRestriction: 1,
        // 发起人会员等级限制
        initiatorGradeIds: [],
        // 发起人会员等级
        initiatorPrize: [],
        // 发起人奖励
        helperRestriction: 1,
        // 助力者会员等级限制
        helperGradeIds: [],
        // 助力者会员等级
        helperPrize: [] // 助力者奖励
      },
      rules: {
        title: [{
          required: true,
          message: '请输入活动标题',
          trigger: 'blur'
        }],
        subtitle: [{
          required: true,
          message: '请输入活动副标题',
          trigger: 'blur'
        }],
        stock: [{
          required: true,
          message: '请输入库存数量',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            if (value == null || value < _this.totalStockTip) {
              callback(new Error('总库存必须大于等于发起者奖励库存之和'));
            } else {
              callback();
            }
          },
          trigger: 'change'
        }],
        enabled: [{
          required: true,
          message: '请选择是否启动',
          trigger: 'change'
        }],
        inviteCount: [{
          required: true,
          message: '请输入邀请人数',
          trigger: 'blur'
        }],
        activityTime: [{
          required: true,
          message: '请选择活动时间',
          trigger: 'change'
        }],
        cityRestriction: [{
          required: true,
          message: '请选择城市限制',
          trigger: 'change'
        }],
        cityIds: [{
          required: true,
          message: '请选择城市ID列表',
          trigger: 'change'
        }],
        headerImage: [{
          required: true,
          message: '请上传活动页头图',
          trigger: 'blur'
        }],
        bgColor: [{
          required: true,
          message: '请输入活动页背景色',
          trigger: 'change'
        }],
        thirdLayerBgColor: [{
          required: true,
          message: '请输入第三层背景色',
          trigger: 'change'
        }],
        fissionCardFgColor: [{
          required: true,
          message: '请输入裂变卡片前景色',
          trigger: 'change'
        }],
        otherCardFgColor: [{
          required: true,
          message: '请输入其他卡片前景色',
          trigger: 'change'
        }],
        cardTitleColor: [{
          required: true,
          message: '请输入卡片标题色',
          trigger: 'change'
        }],
        fissionNumColor: [{
          required: true,
          message: '请输入剩余裂变数字颜色',
          trigger: 'change'
        }],
        btnTextColor: [{
          required: true,
          message: '请输入按钮文字色1',
          trigger: 'change'
        }],
        btnBgColor: [{
          required: true,
          message: '请输入按钮背景色1',
          trigger: 'change'
        }],
        btnTextColor2: [{
          required: true,
          message: '请输入按钮文字色2',
          trigger: 'change'
        }],
        btnBgColor2: [{
          required: true,
          message: '请输入按钮背景色2',
          trigger: 'change'
        }],
        progressIcon: [{
          required: true,
          message: '请上传进度icon',
          trigger: 'change'
        }],
        progressBarImage: [{
          required: true,
          message: '请上传进度条切图',
          trigger: 'change'
        }],
        helperBackgroundImage: [{
          required: true,
          message: '请上传助力人背景图',
          trigger: 'change'
        }],
        shareCardImage: [{
          required: true,
          message: '请上传分享卡片图',
          trigger: 'change'
        }],
        posterImage: [{
          required: true,
          message: '请上传海报图',
          trigger: 'change'
        }],
        fissionPopupBg: [{
          required: true,
          message: '请上传领取裂变弹窗背景图',
          trigger: 'change'
        }],
        fissionNumBgImg: [{
          required: true,
          message: '请上传剩余裂变数字背景图',
          trigger: 'change'
        }],
        initiatorRewardImage: [{
          required: true,
          message: '请上传发起者奖励图',
          trigger: 'change'
        }],
        helperRewardImage: [{
          required: true,
          message: '请上传助力者奖励图',
          trigger: 'change'
        }],
        middlePageImage: [{
          required: true,
          message: '请上传中间页展示图',
          trigger: 'change'
        }],
        ruleText: [{
          required: true,
          message: '请输入规则文本',
          trigger: 'blur'
        }],
        initiatorRestriction: [{
          required: true,
          message: '请选择发起人会员等级限制',
          trigger: 'change'
        }],
        initiatorGradeIds: [{
          required: true,
          message: '请选择发起人会员等级',
          trigger: 'change'
        }],
        initiatorPrize: [{
          required: true,
          message: '请输入发起人奖励',
          trigger: 'change'
        }, {
          validator: function validator(rule, value, callback) {
            return _this.validatePrizeItems(value, callback);
          },
          trigger: 'change'
        }],
        helperRestriction: [{
          required: true,
          message: '请选择助力者会员等级限制',
          trigger: 'change'
        }],
        helperGradeIds: [{
          required: true,
          message: '请选择助力者会员等级',
          trigger: 'change'
        }],
        helperPrize: [{
          required: true,
          message: '请输入助力者奖励',
          trigger: 'change'
        }, {
          validator: function validator(rule, value, callback) {
            return _this.validatePrizeItems(value, callback);
          },
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    totalStockTip: function totalStockTip() {
      var totalStock = 0;
      if (this.form.initiatorPrize.length > 0) {
        for (var i = 0; i < this.form.initiatorPrize.length; i++) {
          totalStock += this.form.initiatorPrize[i].stock || 0;
        }
      }
      return totalStock;
    }
  },
  watch: {
    'form.initiatorPrize': {
      deep: true,
      handler: function handler() {
        if (this.$refs.form) {
          this.$refs.form.validateField('stock');
        }
      }
    },
    'form.headerImage': function formHeaderImage(val) {
      this.$refs.form.validateField('headerImage');
    },
    'form.progressIcon': function formProgressIcon(val) {
      this.$refs.form.validateField('progressIcon');
    },
    'form.progressBarImage': function formProgressBarImage(val) {
      this.$refs.form.validateField('progressBarImage');
    },
    'form.helperBackgroundImage': function formHelperBackgroundImage(val) {
      this.$refs.form.validateField('helperBackgroundImage');
    },
    'form.shareCardImage': function formShareCardImage(val) {
      this.$refs.form.validateField('shareCardImage');
    },
    'form.posterImage': function formPosterImage(val) {
      this.$refs.form.validateField('posterImage');
    },
    'form.fissionPopupBg': function formFissionPopupBg(val) {
      this.$refs.form.validateField('fissionPopupBg');
    },
    'form.fissionNumBgImg': function formFissionNumBgImg(val) {
      this.$refs.form.validateField('fissionNumBgImg');
    },
    'form.initiatorRewardImage': function formInitiatorRewardImage(val) {
      this.$refs.form.validateField('initiatorRewardImage');
    },
    'form.helperRewardImage': function formHelperRewardImage(val) {
      this.$refs.form.validateField('helperRewardImage');
    },
    'form.middlePageImage': function formMiddlePageImage(val) {
      this.$refs.form.validateField('middlePageImage');
    }
  },
  created: function created() {
    this.getImageAccessDomain();
    this.getMemberLevelCombo();
    this.getGagaAreaCombo();
    // 初始化发起人奖励列表并添加一项
    this.form.initiatorPrize = [];
    this.addInitiatorPrize();

    // 初始化助力者奖励列表并添加一项
    this.form.helperPrize = [];
    this.addHelperPrize();
    if (this.id) {
      this.getFissionActivity();
    }
  },
  methods: {
    getFissionActivity: function getFissionActivity() {
      var _this2 = this;
      (0, _fission.queryFissionActivity)(this.id).then(function (res) {
        var data = res.data;
        if (data) {
          _this2.form.title = data.title; // 活动标题
          _this2.form.subtitle = data.subtitle; // 活动副标题
          _this2.form.activityTime = data.activityTime; // 活动时间
          _this2.form.stock = data.stock; // 库存数量
          _this2.stock = data.stock; // 当前库存数量 修改只能增加不可以减少
          _this2.form.enabled = data.enabled; // 是否启动
          _this2.form.checkScalper = !!data.checkScalper;
          _this2.form.inviteCount = data.inviteCount; // 邀请人数
          _this2.form.cityRestriction = data.cityRestriction; // 城市限制
          _this2.form.cityIds = data.cityIds; // 城市ID列表
          _this2.form.headerImage = data.headerImage; // 活动页头图
          _this2.form.bgColor = data.bgColor; // 活动页背景色
          _this2.form.thirdLayerBgColor = data.thirdLayerBgColor; // 第三层背景色
          _this2.form.fissionCardFgColor = data.fissionCardFgColor; // 裂变卡片前景色
          _this2.form.otherCardFgColor = data.otherCardFgColor; // 其他卡片前景色
          _this2.form.cardTitleColor = data.cardTitleColor; // 卡片标题色
          _this2.form.fissionNumColor = data.fissionNumColor; // 剩余裂变数字颜色
          _this2.form.btnTextColor = data.btnTextColor; // 按钮文字色1
          _this2.form.btnBgColor = data.btnBgColor; // 按钮背景色1
          _this2.form.btnTextColor2 = data.btnTextColor2; // 按钮文字色2
          _this2.form.btnBgColor2 = data.btnBgColor2; // 按钮背景色2
          _this2.form.progressIcon = data.progressIcon; // 进度icon
          _this2.form.progressBarImage = data.progressBarImage; // 进度条切图
          _this2.form.helperBackgroundImage = data.helperBackgroundImage; // 助力人背景图
          _this2.form.shareCardImage = data.shareCardImage; // 分享卡片图
          _this2.form.posterImage = data.posterImage; // 海报图
          _this2.form.fissionPopupBg = data.fissionPopupBg; // 领取裂变弹窗背景图
          _this2.form.fissionNumBgImg = data.fissionNumBgImg; // 剩余裂变数字背景图
          _this2.form.initiatorRewardImage = data.initiatorRewardImage; // 发起者奖励图
          _this2.form.helperRewardImage = data.helperRewardImage; // 助力者奖励图
          _this2.form.middlePageImage = data.middlePageImage; // 中间页展示图
          _this2.form.ruleText = data.ruleText; // 规则文本
          _this2.form.initiatorRestriction = data.initiatorRestriction; // 发起人会员等级限制
          _this2.form.initiatorGradeIds = data.initiatorGradeIds; // 发起人会员等级
          _this2.form.initiatorPrize = []; // 发起人奖励
          if (data.initiatorPrize) {
            for (var i = 0; i < data.initiatorPrize.length; i++) {
              var prize = data.initiatorPrize[i];
              var item = {
                prizeType: prize.prizeType,
                couponId: prize.couponId,
                stock: prize.stock,
                couponCount: prize.couponCount,
                winRate: prize.winRate,
                integral: prize.integral
              };
              _this2.form.initiatorPrize.push(item);
            }
          }
          _this2.form.helperRestriction = data.helperRestriction; // 助力者会员等级限制
          _this2.form.helperGradeIds = data.helperGradeIds; // 助力者会员等级
          _this2.form.helperPrize = []; // 助力者奖励
          if (data.helperPrize) {
            for (var _i = 0; _i < data.helperPrize.length; _i++) {
              var _prize = data.helperPrize[_i];
              var _item = {
                prizeType: _prize.prizeType,
                couponId: _prize.couponId,
                stock: _prize.stock,
                couponCount: _prize.couponCount,
                winRate: _prize.winRate,
                integral: _prize.integral
              };
              _this2.form.helperPrize.push(_item);
            }
          }
        }
      });
    },
    reset: function reset() {
      this.form.title = ''; // 活动标题
      this.form.subtitle = ''; // 活动副标题
      this.form.activityTime = []; // 活动时间
      this.form.stock = 1; // 库存数量，初始值设为1
      this.form.enabled = true; // 是否启动，初始值设为true
      this.form.checkScalper = false;
      this.form.inviteCount = 5; // 邀请人数，初始值设为5
      this.form.cityRestriction = 1; // 城市限制，初始值设为1
      this.form.cityIds = []; // 城市ID列表
      this.form.headerImage = ''; // 活动页头图
      this.form.bgColor = ''; // 活动页背景色
      this.form.thirdLayerBgColor = ''; // 第三层背景色
      this.form.fissionCardFgColor = ''; // 裂变卡片前景色
      this.form.otherCardFgColor = ''; // 其他卡片前景色
      this.form.cardTitleColor = ''; // 卡片标题色
      this.form.fissionNumColor = ''; // 剩余裂变数字颜色
      this.form.btnTextColor = ''; // 按钮文字色1
      this.form.btnBgColor = ''; // 按钮背景色1
      this.form.btnTextColor2 = ''; // 按钮文字色2
      this.form.btnBgColor2 = ''; // 按钮背景色2
      this.form.progressIcon = ''; // 进度icon
      this.form.progressBarImage = ''; // 进度条切图
      this.form.helperBackgroundImage = ''; // 助力人背景图
      this.form.shareCardImage = ''; // 分享卡片图
      this.form.posterImage = ''; // 海报图
      this.form.fissionPopupBg = ''; // 领取裂变弹窗背景图
      this.form.fissionNumBgImg = ''; // 剩余裂变数字背景图
      this.form.initiatorRewardImage = ''; // 发起者奖励图
      this.form.helperRewardImage = ''; // 助力者奖励图
      this.form.middlePageImage = ''; // 中间页展示图
      this.form.ruleText = ''; // 规则文本
      this.form.initiatorRestriction = 1; // 发起人会员等级限制
      this.form.initiatorGradeIds = []; // 发起人会员等级
      this.form.initiatorPrize = []; // 发起人奖励
      this.form.helperRestriction = 1; // 助力者会员等级限制
      this.form.helperGradeIds = []; // 助力者会员等级
      this.form.helperPrize = []; // 助力者奖励
      // 初始化发起人奖励列表并添加一项
      this.addInitiatorPrize();
      // 初始化助力者奖励列表并添加一项
      this.addHelperPrize();
    },
    submit: function submit() {
      var _this3 = this;
      console.log('submit');
      this.loading = true;
      this.$refs.form.validate(function (valid, invalidFields) {
        if (valid) {
          (0, _fission.addFissionActivity)(_this3.form).then(function (res) {
            console.log('addFissionActivity', res);
            _this3.loading = false;
            _this3.$message.success('保存成功');
            _this3.$emit('toTable');
          }).catch(function (err) {
            console.log('addFissionActivity', err);
            _this3.loading = false;
          });
        } else {
          _this3.loading = false;
          _this3.handleValidateFail(invalidFields);
        }
      });
    },
    validatePrizeItems: function validatePrizeItems(value, callback) {
      if (!value || !value.length) {
        callback(new Error('请添加奖励'));
        return;
      }
      for (var i = 0; i < value.length; i++) {
        var prize = value[i];
        var prefix = value.length > 1 ? '第' + (i + 1) + '项' : '';
        if (prize.prizeType === 1) {
          if (!prize.couponId) {
            callback(new Error(prefix + '请选择代金券'));
            return;
          }
          if (prize.stock == null || prize.stock < 1) {
            callback(new Error(prefix + '请输入券库存'));
            return;
          }
          if (prize.couponCount == null || prize.couponCount < 1) {
            callback(new Error(prefix + '请输入单次发放数量'));
            return;
          }
        } else if (prize.prizeType === 2) {
          if (prize.integral == null || prize.integral < 1) {
            callback(new Error(prefix + '请输入积分'));
            return;
          }
        } else {
          callback(new Error(prefix + '请选择奖品类型'));
          return;
        }
      }
      callback();
    },
    getFirstValidateMessage: function getFirstValidateMessage(invalidFields) {
      if (!invalidFields) return '';
      var keys = Object.keys(invalidFields);
      if (!keys.length) return '';
      var list = invalidFields[keys[0]];
      if (Array.isArray(list) && list[0] && list[0].message) {
        return list[0].message;
      }
      return '';
    },
    handleValidateFail: function handleValidateFail(invalidFields) {
      var _this4 = this;
      var firstMsg = this.getFirstValidateMessage(invalidFields);
      this.$message.warning(firstMsg || '请完善必填项');
      this.$nextTick(function () {
        var errorItem = _this4.$el.querySelector('.el-form-item.is-error');
        if (errorItem && errorItem.scrollIntoView) {
          errorItem.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        }
      });
    },
    addHelperPrize: function addHelperPrize() {
      // 添加助力者一项奖励
      var prize = {
        prizeType: 1,
        couponId: '',
        stock: 0,
        couponCount: 0,
        winRate: 0,
        integral: 0
      };
      this.form.helperPrize.push(prize);
    },
    removeHelperPrize: function removeHelperPrize(idx) {
      // 移除助力者一项奖励
      this.form.helperPrize.splice(idx, 1);
    },
    removeInitiatorPrize: function removeInitiatorPrize(idx) {
      // 移除发起人一项奖励
      this.form.initiatorPrize.splice(idx, 1);
    },
    addInitiatorPrize: function addInitiatorPrize() {
      // 添加发起人一项奖励
      var prize = {
        prizeType: 1,
        couponId: '',
        stock: 0,
        couponCount: 0,
        winRate: 0,
        integral: 0
      };
      this.form.initiatorPrize.push(prize);
    },
    getImageAccessDomain: function getImageAccessDomain() {
      var _this5 = this;
      (0, _sys_cons.queryImageAccessDomain)().then(function (res) {
        _this5.imageAccessDomain = res.data || '';
      });
    },
    getMemberLevelCombo: function getMemberLevelCombo() {
      var _this6 = this;
      (0, _sys_cons.queryMemberLevelCombo)().then(function (res) {
        _this6.memberLevelList = res.data || [];
      });
    },
    getGagaAreaCombo: function getGagaAreaCombo() {
      var _this7 = this;
      (0, _sys_cons.queryGagaAreaCombo)().then(function (res) {
        _this7.gagaAreaList = res.data || [];
      });
    }
  }
};